Tollwerk.Init.registerOnReady(function () {
    new TwReadMore.Element(document.querySelector('.BlogContentNav__list'), '.BlogContentNav__item:nth-child(5) ~ *', 0, true);
});

